var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.862,
    height: 27.86,
    viewBox: "0 0 27.862 27.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72734",
    "data-name": "Group 72734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M13.931,0a13.93,13.93,0,1,0,13.931,13.93A13.931,13.931,0,0,0,13.931,0Zm0,4.165A4.608,4.608,0,1,1,9.324,8.774,4.608,4.608,0,0,1,13.931,4.166Zm0,20.053A10.224,10.224,0,0,1,7.27,21.764a1.964,1.964,0,0,1-.689-1.492,4.647,4.647,0,0,1,4.67-4.646h5.362a4.64,4.64,0,0,1,4.662,4.646,1.959,1.959,0,0,1-.688,1.492A10.22,10.22,0,0,1,13.928,24.219Z",
    transform: "translate(0 -0.001)",
    fill: "#2f2f2f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.879d6af8788dfdf2ce567ea181263e0a.svg";
export { ForwardRef as ReactComponent };